
import { mapActions } from 'vuex'
import CartView from '@app/Cart/View'
import ModalWrapper from '@app/Forms/ModalWrapper'
import { analyticCartAdd } from '@analytic/cart.js'

import {
  AnswerMessage,
} from '@utils/submit'

export default {
  name: 'AddToCart',
  props: {
    id: {
      type: [String, Number],
    },
    type: {
      type: String,
    },
    amount: {
      type: [String, Number],
    },
    price: {},
    name: {},
    maxCount: {},
  },
  methods: {
    ...mapActions('cart', [
      'changeCart',
    ]),
    async addToCart(id, type, amount) {
      const data = {
        element: {
          id: id || this.id,
          type: type || this.type,
        },
        quantity: amount || this.amount,
      }
      const entities = []
      entities.push(data)
      try {
        await this.changeCart({ entities }).then(async () => {
          analyticCartAdd(
            this.name, this.id, this.price, this.amount
          )
        })
        this.openCart()
        this.$emit('success')
      } catch (e) {
        console.log(e);
        const meta = {
          messages: [{
            title: this._('Максимальна кількость товарів перевищена. Даний товар вже є у кошику'),
            // eslint-disable-next-line prefer-template
            text: this._('Цей Товар можна замовити лише у кількості') + ' ' + this.maxCount + ' ' + this._('шт.'),
          }],
          timeout: 5000,
        }
        AnswerMessage(meta, this)
      }
    },
    openCart() {
      this.$modal.show(
        ModalWrapper,
        {
          info: {
            tag: CartView,
          },
        }, {
          height: 'auto',
          classes: ['cart-modal'],
          adaptive: true,
          scrollable: true,
        }
      )
    },
  },
  render() {
    window.umallAddToCart = this.addToCart
    return this.$scopedSlots.default({
      add: () => {
        this.addToCart()
      },
    })
  },
}
